import { fadeInit, fadeEnter, fadeLeave } from './fade';
import { buttonCircularInit, buttonCircularEnter, buttonCircularLeave } from './buttonCircular';
import { buttonRoundedInit, buttonRoundedEnter, buttonRoundedLeave } from './buttonRounded';
import { bannerInit, bannerEnter } from './banner';

const init = new Map();
init.set('fade', fadeInit);
init.set('buttonCircular', buttonCircularInit);
init.set('buttonRounded', buttonRoundedInit);
init.set('banner', bannerInit);

const enter = new Map();
enter.set('fade', fadeEnter);
enter.set('buttonCircular', buttonCircularEnter);
enter.set('buttonRounded', buttonRoundedEnter);
enter.set('banner', bannerEnter);

const leave = new Map();
leave.set('fade', fadeLeave);
leave.set('buttonCircular', buttonCircularLeave);
leave.set('buttonRounded', buttonRoundedLeave);

export { init, enter, leave };
